const POLL_INTERVAL = 2000

async function pollRecipeReady(http, recipeId, signal) {
  while (true) {
    if (signal && signal.aborted) {
      const err = new Error('Polling aborted')
      err.name = 'AbortError'
      throw err
    }

    try {
      const res = await http.get(`/recipes/${encodeURIComponent(recipeId)}/get`)
      if (res && res.recipe) {
        return res.recipe
      }
    } catch (e) {
      // 404 means still processing — keep polling
      if (!e.status || e.status !== 404) {
        throw e
      }
    }

    await new Promise((resolve, reject) => {
      const timer = setTimeout(resolve, POLL_INTERVAL)
      if (signal) {
        const onAbort = () => {
          clearTimeout(timer)
          const err = new Error('Polling aborted')
          err.name = 'AbortError'
          reject(err)
        }
        if (signal.aborted) {
          clearTimeout(timer)
          onAbort()
          return
        }
        signal.addEventListener('abort', onAbort, { once: true })
      }
    })
  }
}

export const recipeClient = http => {
  const getAllRecipes = async () => {
    const res = await http.get(`/recipes/get_all`)
    return res && res.recipes
  }
  const getRecipe = async recipeId => {
    const res = await http.get(`/recipes/${encodeURIComponent(recipeId)}/get`)
    return res && res.recipe
  }
  const createExecution = async recipeId => {
    const res = await http.post(`/recipes/${encodeURIComponent(recipeId)}/create_execution`)
    return res && res.execution
  }
  const parseRecipe = async (recipeText, opts = {}) => {
    const res = await http.post(`/recipes/parse`, { recipe_text: recipeText })
    if (!res || !res.recipe_id) throw new Error('No recipe ID returned')
    return pollRecipeReady(http, res.recipe_id, opts.signal)
  }
  const refineRecipe = async (recipe, feedback, opts = {}) => {
    const res = await http.post(`/recipes/refine`, { recipe, feedback })
    if (!res || !res.recipe_id) throw new Error('No recipe ID returned')
    return pollRecipeReady(http, res.recipe_id, opts.signal)
  }
  const saveRecipe = async (recipe, name) => {
    const res = await http.post(`/recipes/save`, { recipe, name })
    return res && res.recipe
  }
  return { getAllRecipes, getRecipe, createExecution, parseRecipe, refineRecipe, saveRecipe }
}
